module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showRaw) ? _c('pg-fill-modal', {
    ref: "rawModal",
    on: {
      "click": function($event) {
        _vm.showRaw = false
      }
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('pre', [_vm._v(_vm._s(_vm.rawData))])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('pg-sidepanel', {
    attrs: {
      "brand": _vm.brand
    }
  }, [_c('pg-sidepanel-item', {
    attrs: {
      "title": "Organizations",
      "active": _vm.$route.path == '/',
      "href": "#/",
      "cls": "m-t-50"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "page-container full-height"
  }, [_c('pg-navbar', {
    attrs: {
      "brand": _vm.brand,
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content-wrapper full-height"
  }, [_c('div', {
    staticClass: "content full-height"
  }, [_c('router-view')], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('pg-login', {
    attrs: {
      "brand": _vm.brand
    },
    on: {
      "login": _vm.onLogin
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c6eed9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1364
// module chunks = 1